if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      // Legacy popup — only used as a fallback if the custom cart drawer
      // isn't available on this page.
      this.cartNotification = document.querySelector('cart-notification');
      this.quickshop = this.closest('.quickshop-modal');
      this.atcButton = document.querySelector('.product-form__submit');
      this.dynamicCheckout = document.querySelector('.shopify-payment-button');
    }

    // The custom drawer is usable when both its markup and its JS
    // (cart-drawer.js) are present on the page.
    hasCartDrawer() {
      return (
        document.querySelector('.cart-drawer') &&
        typeof openCartDrawer === 'function' &&
        typeof updateCartDrawer === 'function'
      );
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const useDrawer = this.hasCartDrawer();
      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      // Instant feedback: open the drawer immediately with a loading state.
      if (useDrawer) {
        openCartDrawer();
        if (typeof setCartDrawerLoading === 'function') setCartDrawerLoading(true);
      } else if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      // Ask Shopify to return the rendered sections we actually need in the
      // same response as the add — one round trip total.
      const sections = useDrawer
        ? ['cart-drawer', 'cart-icon-bubble']
        : this.cartNotification
          ? this.cartNotification.getSectionsToRender().map((section) => section.id)
          : [];

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections: sections,
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then(async (parsedState) => {
          // /cart/add.js signals failures (sold out, invalid variant) as
          // { status, message, description } instead of a line item.
          if (parsedState.status && parsedState.status !== 200) {
            console.error('Add to cart failed:', parsedState.description || parsedState.message);
            if (useDrawer) await updateCartDrawer(); // re-sync with real cart state
            return;
          }

          if (useDrawer) {
            // Render the drawer from the piggybacked HTML — no extra request.
            await updateCartDrawer(parsedState.sections && parsedState.sections['cart-drawer']);

            // Header cart bubble: swap the returned section if available,
            // otherwise fall back to a background count fetch.
            const bubbleTarget = document.getElementById('cart-icon-bubble');
            const bubbleHTML = parsedState.sections && parsedState.sections['cart-icon-bubble'];
            if (bubbleTarget && bubbleHTML) {
              const parsed = new DOMParser().parseFromString(bubbleHTML, 'text/html');
              const inner = parsed.querySelector('.shopify-section') || parsed.body;
              if (inner) bubbleTarget.innerHTML = inner.innerHTML;
            } else if (typeof updateCartItemCounts === 'function') {
              fetch('/cart.js')
                .then((r) => r.json())
                .then((cart) => updateCartItemCounts(cart.item_count))
                .catch(() => {});
            }
          } else if (this.cartNotification) {
            // Legacy popup path (guarded so a missing element can't throw
            // and silently kill the flow).
            try {
              this.cartNotification.renderContents(parsedState);
            } catch (err) {
              console.error('cart-notification render failed:', err);
            }
          }
        })
        .catch((e) => {
          console.error(e);
          // If the drawer was optimistically opened, make sure it reflects
          // the real cart rather than sitting stale.
          if (useDrawer) updateCartDrawer().catch(() => {});
        })
        .finally(() => {
          if (useDrawer && typeof setCartDrawerLoading === 'function') {
            setCartDrawerLoading(false);
          }
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
          if (this.quickshop) {
            this.quickshop.hide();
          }
        });
    }

    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.showDynamicCheckout());
      } else {
        this.showDynamicCheckout();
      }
    }

    showDynamicCheckout() {
      // Guarded: pages/blocks without a payment button used to throw here.
      if (this.dynamicCheckout) {
        this.dynamicCheckout.style.setProperty('display', 'block', 'important');
        this.dynamicCheckout.classList.add('force-display');
      }
      if (this.atcButton) {
        this.atcButton.style.setProperty('max-width', 'none', 'important');
      }
    }
  });
}